import { combineReducers } from 'redux';

import { actionReducer } from './action';
import { activityReducer } from './activity';
import { activityTypeReducer } from './activityType';
import { areaReducer } from './area';
import { branchReducer } from './branch';
import { companyReducer } from './company';
import { distributionCenterReducer } from './distributionCenter';
import { employeeReducer } from './employee';
import { errorMessageReducer } from './errorMessage';
import { fileReducer } from './file';
import { improvementAreaReducer } from './improvementArea';
import { producedActivityReducer } from './producedActivity';
import { subZoneReducer } from './subZone';
import { suggestionReducer } from './suggestion';
import { unitOfMeasureReducer } from './unitOfMeasure';
import { zoneReducer } from './zone';

const dataReducers = combineReducers({
  company: companyReducer,
  branch: branchReducer,
  zone: zoneReducer,
  subZone: subZoneReducer,
  distributionCenter: distributionCenterReducer,
  area: areaReducer,
  activity: activityReducer,
  activityType: activityTypeReducer,
  employee: employeeReducer,
  producedActivity: producedActivityReducer,
  errorMessage: errorMessageReducer,
  suggestion: suggestionReducer,
  action: actionReducer,
  improvementArea: improvementAreaReducer,
  file: fileReducer,
  unitOfMeasure: unitOfMeasureReducer,
});

export default dataReducers;
